export default "__VITE_ASSET__DD1NM86O__"